import {Injectable} from '@angular/core';
import {Actions, Effect, ofType} from '@ngrx/effects';
import {Action} from '@ngrx/store';
import {Observable} from 'rxjs';
import {tap} from 'rxjs/operators';
import {BpmnModelerService} from '@ispm-client/modules/bpmn-modeler/service/bpmn-modeler.service';
import {
  NodeActionTypes, UpdateTreatmentNodesProperties
} from "@ispm-client/modules/bpmn-modeler/store/actions";

@Injectable()
export class UpdateTreatmentNodesPropertiesEffect {
  constructor(private actions$: Actions,
              private bpmnModelerService: BpmnModelerService) {
  }

  @Effect({dispatch: false})
  updateTreatmentNodesPropertiesEffect$: Observable<Action> = this.actions$
    .pipe(
      ofType<UpdateTreatmentNodesProperties>(NodeActionTypes.UPDATE_TREATMENT_NODES_PROPERTIES),
      tap((action: UpdateTreatmentNodesProperties) => {
        return this.bpmnModelerService.updateTreatmentNodesProperties(action.payload.nodes, action.payload.data);
      })
    );
}
